import React, {useEffect, useImperativeHandle, useState} from "react";
import {Button, Form, Modal, Row, Table} from "antd";
import Icons from "assets/icons";
import dayjs from "dayjs";
import "./ModalSpecify.scss";
import {SuccessSVG} from "assets";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setListAssign} from "redux/reducer/listAssign";
import {
  trangThaiOptions,
  trangThaiTTOptions,
} from "assets/constants/kbnt-category";
import {examinationService} from "api";
import {convertIosStringToDate, formatToCurrencyType} from "helper/common";
import {Notification} from "components/common";
const ModalSpecify = React.forwardRef((props, ref) => {
  // redux

  const dispatch = useAppDispatch();
  //state

  const [dataTable, setDataTable] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [record, setRecord] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setRecord: setRecord,
  }));
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const columnsSpecifyList: any = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      render: (text, record, index) => index + 1,
      align: "center",
    },
    {
      title: "Mã Dịch vụ",
      dataIndex: "maDichVu",
      key: "maDichVu",
      align: "left",
    },
    {
      title: "Tên dịch vụ",
      dataIndex: "tenChiDinh",
      key: "tenChiDinh",
      align: "left",
    },
    {
      title: "Đơn giá",
      dataIndex: "donGia",
      key: "donGia",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
    },
    {
      title: "Đơn giá BHYT",
      dataIndex: "baoHiemTra",
      key: "bhChiTra",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
    },
    {
      title: "Ngày chỉ định",
      dataIndex: "thoiGian",
      key: "thoiGian",
      align: "left",
      render: (v, r, i) => convertIosStringToDate(v)?.format("HH:mm DD/MM/YYYY"),
    },
    {
      title: "Tư vấn",
      dataIndex: "canTuVan",
      key: "canTuVan",
      render: tv => {
        if (tv) return <SuccessSVG />;
      },
    },
    {
      title: "Trạng thái TT",
      dataIndex: "trangThaiThanhToan",
      key: "trangThaiThanhToan",
      render: (v, r, i) =>
        trangThaiTTOptions.find(it => it.value === v)?.label || "",
    },
    {
      title: "Trạng thái HĐ",
      dataIndex: "trangThai",
      key: "trangThai",
      render: (v, r, i) =>
        trangThaiOptions.find(it => it.value === v)?.label || "",
    },
    {
      title: "Số lượng",
      dataIndex: "soLuong",
      align: "right",
    },
    {
      title: "Ghi chú",
      dataIndex: "ghiChu",
      key: "ghiChu",
      editable: true,
    },
    {
      title: "",
      key: "xoa",
      dataIndex: "xoa",
      render: (v, r, i) => {
        const handleDelete = async () => {
          try {
            let response = await examinationService.deleteChiDinhTrongPhieu({
              id: r.id,
            });
            fetchPhieuChiDinh({
              id: record.id,
            });
          } catch (err) {
            if (
              err?.response?.data ==
              "Xóa không thành công do có chỉ định đã được thanh toán"
            ) {
              Notification(
                "warning",
                "Xóa không thành công do chỉ định đã được thanh toán"
              );
            } else {
              Notification("error", "Đã có lỗi khi xóa chỉ định");
            }
          }
        };
        return (
          <Button
            icon={<Icons.remove rev={0} />}
            onClick={handleDelete}
            danger
          ></Button>
        );
      },
    },
  ];
  const mapNumber = data => {
    if (!data) return [];
    let tmp = [];
    data.map(it => {
      let tmp2 = Array.from({length: it.soLuong}, () => ({...it}));
      tmp = [...tmp, ...tmp2];
    });
    return tmp;
  };
  const handlePaginationChange = page => {
    setCurrentPage(page);
  };
  const fetchPhieuChiDinh = async params => {
    try {
      setLoading(true);
      let response = await examinationService.getPhieuChiDinh(params);
      let tmp = [];
      response.nhomChiDinhDtos?.map(it => {
        tmp = [...tmp, ...it.chiDinhDtos];
      });
      setDataTable(tmp);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    onChange: handlePaginationChange,
  };

  const [formData] = Form.useForm();
  const handleSave = async () => {};
  useEffect(() => {
    if (record) {
      fetchPhieuChiDinh({
        id: record.id,
      });
    } else {
      setDataTable([]);
    }
  }, [record]);

  return (
    <Modal
      title="Danh sách dịch vụ trong phiếu"
      centered
      open={isModalOpen}
      onCancel={closeModal}
      width={"80%"}
      className="modal-results-specify"
      footer=""
    >
      <div className="table-results">
        <Row gutter={[8, 8]}>
          <Row>
            <Table
              dataSource={dataTable}
              bordered
              columns={columnsSpecifyList}
              // pagination={{
              //   position: ["bottomRight"],
              //   showSizeChanger: true,
              // }}
              pagination={false}
              loading={loading}
            />
          </Row>
          <Row>
            <Row justify={"end"} style={{gap: "4px"}}>
              <Button key="cancel" type="primary" danger onClick={closeModal}>
                Đóng
              </Button>
            </Row>
          </Row>
        </Row>
      </div>
    </Modal>
  );
});

export default ModalSpecify;
